/****************************************************
 * Module Name:  shadeProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class ShadeProxy {
  static GetAllShade = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/shade",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllShadeMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/shade/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleShade = (shadeId, callback) => {
    let params = {
      id: shadeId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/shade",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckShadeAvailable = (shade, callback) => {
    let params = {
      shade: shade,
    };

    restAPICall(
      Constants.MANAGER_URL + "/shade/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddShade = (shade, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/shade",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(shade),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateShade = (shade, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/shade",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(shade),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteShade = (shade, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/shade",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(shade),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
